import { Button, Card } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import usePaywall from '../../../hooks/use-paywall';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';

const RampGuidanceSubscribePage: FC = () => {
  const history = useHistory();
  const { presentPaywall, hasActiveSubscription } = usePaywall(
    'Ramp guidance subscription page',
  );

  const handleSoundsGood = () => {
    captureEvent({
      type: 'ramp-guidance: click sounds good',
      payload: {},
    });

    history.push('/maps');
  };

  return (
    <SheetLayout heading="Supporters Club" showMenuBar={false}>
      <SheetBody>
        <Card>
          <Card.Heading size="compact">
            Ramp guidance is being considered as a Supporters Club feature
          </Card.Heading>
          {hasActiveSubscription && (
            <Card.Body>
              As a member of the Supporters Club, you’ll be the first to know if
              this feature is made available.
            </Card.Body>
          )}
          {hasActiveSubscription && (
            <Card.Body>
              <Button.Group wide>
                <Button onClick={handleSoundsGood}>Sounds good</Button>
              </Button.Group>
            </Card.Body>
          )}
          {!hasActiveSubscription && (
            <Card.Body>
              Join DECKEE Supporters Club to unlock 3D maps, unlimited automatic
              logbook and more.
            </Card.Body>
          )}
          {!hasActiveSubscription && (
            <Card.Body>
              <Button.Group wide>
                <Button onClick={presentPaywall}>Join Supporters Club</Button>
              </Button.Group>
            </Card.Body>
          )}
        </Card>
      </SheetBody>
    </SheetLayout>
  );
};

export default RampGuidanceSubscribePage;
